// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"7b664be7","116":"e82740e1","216":"49ed4065","242":"38e43d19","248":"77699e5a"}[chunkId] + ".chunk.js";
};